import "./Carousel.css";
import CarouselCard from "./CarouselCard";

type Props = { films: any[]; title: string; highlight?: string; eyebrow?: string; limit?: number };

const Carousel = ({ films, title, highlight, eyebrow, limit = 18 }: Props) => {
  return (
    <section className="carousel">
      {eyebrow && <div className="carousel__eyebrow"><span>{eyebrow}</span></div>}
      <h2 className="carousel__header">
        <span className="carousel__title">{title}</span>{" "}
        {highlight && <span className="carousel__highlight">{highlight}</span>}
      </h2>
      <div className="carousel__container">
        {films.slice(0, limit).map((film: any) => (
          <CarouselCard key={film.id} {...film} />
        ))}
      </div>
    </section>
  );
};

export default Carousel;
